export default __webpack_public_path__ + "img/logo_dark.jpg";